module.exports = __webpack_public_path__ + "img/why-us-b-lg.00b860d6.svg";